import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import VacanciesState from '../types/VacanciesState'

const mutations: MutationTree<VacanciesState> = {
}

export default mutations
